import React from 'react';
import { render } from 'react-dom';
import * as Sentry from '@sentry/react';
import { ThemeProvider } from 'styled-components';
import { QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import theme from '../../../theme';

// API
import { queryClient } from './api/queryClient';

// Components
import ErrorBoundary from '../../components/ErrorBoundary';
import AuthManager from '../../components/AuthManager';

Sentry.init({
    dsn: process.env.SENTRY_DSN || undefined,
    environment: process.env.SENTRY_ENVIRONMENT || undefined,
    release: process.env.SENTRY_RELEASE || undefined
});

Sentry.setContext('rckms_module', {
    name: 'Public Health Agency Authoring Dashboard'
});

const MountedApp = ({ ...props }) => (
    <ThemeProvider theme={theme}>
        <QueryClientProvider client={queryClient}>
            <AuthManager {...props}>
                {({ userContext }) => (
                    <ErrorBoundary>
                        <App userContext={userContext} />
                    </ErrorBoundary>
                )}
            </AuthManager>
        </QueryClientProvider>
    </ThemeProvider>
);

render(<MountedApp />, document.getElementById('root'));
